import type { FaireProductEntity } from "../../entity_types/product";

export const p_x35bmvrmbj: FaireProductEntity = {
  token: "p_x35bmvrmbj",
  type: "product",
  name: "Clean Ramen Noodles",
  brandToken: "b_42evg3vp59",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/1509efda399226c169d678f6cf8c62dd50e150cc5935ed617578d666680bd015.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c844c937240da9f503310d964180ebffb7a90d7c7e2dc82aaad441e31572af8d.jpeg",
    "https://cdn.faire.com/fastly/53a9ed9dba5a924ed29a842e195fa212d10a5a31ed292de6afc439e2c69127d6.jpeg",
    "https://cdn.faire.com/fastly/05a4c5abcdfaebb20cc34c88c1b90534110dc4251df59ec2d8552172c3ff08aa.jpeg",
    "https://cdn.faire.com/fastly/5b7e39f9f29d37778176599e96ba37c1517945fa89ce644f1f49371ec38e8f69.jpeg",
    "https://cdn.faire.com/fastly/4b36281310bc107c1a0c46038779dd1a0bdf9ce960897c46150f716513c4d00a.jpeg",
  ],
  priceDollars: 17.5,
  description:
    "NEW Clean Ramen Noodles! Sold out three times way faster than we expected. Get them while supplies last! \n\nInspired by the success of our Ramen Seasonings, we created our own 12-pack of Organic Brown Rice Flour noodles ($2.33/meal). Perfect for those with food allergies, restrictions, or just wanting a cleaner option. We fixed common issues: 1) Resealable Bag – no more dried-out noodles; 2) Individually Sealed Cakes – prevents breakage and keeps noodles fresh; 3) Attached Seasoning Packets – each cake comes with its own Chicken Ramen Seasoning on top for easy grab-and-go without digging through the bag. Our mission remains the same: bring hope and nourishment through inclusive, allergy-friendly food. \n\n",
  tags: [],
  msrpDollars: 35,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:50.425Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
